import { createAction } from '@reduxjs/toolkit'
import type { IBreadcrumb } from '@/components/ui/Breadcrumbs/Breadcrumb/interfaces'

const setBreadcrumbs = createAction<IBreadcrumb[]>('BREADCRUMBS/SET')

const clearBreadcrumbs = createAction('BREADCRUMBS/CLEAR')

export { setBreadcrumbs, clearBreadcrumbs }
